/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconDeviceMobileExclamation = createReactComponent(
  "device-mobile-exclamation",
  "IconDeviceMobileExclamation",
  [
    [
      "path",
      {
        d: "M15 21h-7a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v7",
        key: "svg-0"
      }
    ],
    ["path", { d: "M11 4h2", key: "svg-1" }],
    ["path", { d: "M12 17v.01", key: "svg-2" }],
    ["path", { d: "M19 16v3", key: "svg-3" }],
    ["path", { d: "M19 22v.01", key: "svg-4" }]
  ]
);

export { IconDeviceMobileExclamation as default };
//# sourceMappingURL=IconDeviceMobileExclamation.js.map
